<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { getSystemConfig } from '@/api/systemConfig'

export default {
  name: 'App',
  created() {
    this.loadSystemConfig()
  },
  watch: {
    '$route'() {
      window.scrollTo(0, 0)
      document.documentElement.scrollTop = 0
      document.body.scrollTop = 0
    }
  },
  methods: {
    async loadSystemConfig() {
      try {
        const res = await getSystemConfig()
        if (res.code === 200 && res.data) {
          const systemName = res.data.systemName
          const systemLogo = res.data.systemLogo
          // 设置页面标题
          if (systemName) {
            document.title = systemName
          }
          // 设置页面图标
          if (systemLogo) {
            let link = document.querySelector("link[rel*='icon']")
            if (!link) {
              link = document.createElement('link')
              link.rel = 'icon'
              document.head.appendChild(link)
            }
            link.href = systemLogo
          }
        }
      } catch (e) {
        // 忽略错误
      }
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

html::-webkit-scrollbar,
body::-webkit-scrollbar {
  display: none;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100%;
}
</style>
